import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classNames from './Loader.module.css';

type LoaderProps = {
    isVisible: boolean
}

export const Loader = (props: LoaderProps) => {
    if (!props.isVisible) {
        return null
    }

    return (
        <div className={classNames.root}>
            <CircularProgress />
        </div>
    )
}
